import { render } from "./ProjectPageView.vue?vue&type=template&id=e7c5fbb6&scoped=true&ts=true&lang=pug"
import script from "./ProjectPageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectPageView.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectPageView.vue?vue&type=style&index=0&id=e7c5fbb6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7c5fbb6"]])

export default __exports__